<template>
  <div class="bg-info shadow-sm h-100 w-100">
    <b-list-group class="p-1 bg-info rounded-0 border-top text-right">
      <b-list-group-item v-for="(menu, index) in menus" :key="'_index#'+index" active-class="bg-info text-white" :to="menu.to">{{ menu.title }}</b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  props: {
    menus: {
      type: Array
    }
  }
}
</script>